import Vue from 'vue'
import VueRouter from 'vue-router'
import authorization from '../views/authorization.vue'
import converter from '../views/converter.vue'
import archive from '../views/archive.vue'
import provenance from '../views/provenance.vue'
import administration from '@/views/administration.vue'
import pageNotFound from '@/views/page_not_found.vue'
import test from '@/views/test.vue'

import store from '../store/index'

Vue.use(VueRouter)

function isAuthorized(to, from, next) {
  console.log(store);
  if (!store.getters['auth/isAuthorized']) {
    next({ path: '/auth' })
  } else next()
}

// Admin-only pages. The role is only known after verifyToken resolves (a page
// refresh lands here with the default 'USER'), so verify before deciding.
async function isAdmin(to, from, next) {
  if (!store.getters['auth/isAuthorized']) return next({ path: '/auth' })
  if (store.state.auth.userRole !== 'ADMIN') {
    try { await store.dispatch('auth/verifyToken') } catch (e) { return next({ path: '/auth' }) }
  }
  if (store.state.auth.userRole === 'ADMIN') next()
  else next({ path: '/' })
}

const routes = [
  {
    path: '/auth',
    name: 'authorization',
    meta: { layout: 'empty' },
    component: authorization
  },
  {
    path: '/',
    name: 'converter',
    meta: { layout: 'main' },
    component: converter,
    beforeEnter: isAuthorized
  },
  {
    path: '/archive',
    name: 'archive',
    meta: { layout: 'main' },
    component: archive,
    beforeEnter: isAuthorized
  },
  {
    path: '/provenance',
    name: 'provenance',
    meta: { layout: 'main' },
    component: provenance,
    beforeEnter: isAdmin
  },
  {
    path: '/administration',
    name: 'administration',
    meta: {layout: 'main'},
    component: administration,
    beforeEnter: isAdmin
  },
  { 
    path: "*",
    component: pageNotFound,
    meta: {layout: 'main'},
    beforeEnter: isAuthorized
  },
  {
    path: '/test',
    name: 'test',
    meta: {layout: 'main'},
    component: test,
    beforeEnter: isAuthorized
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
